import http from '@/common/request/axios';

export const statisticsService = {
    stats(accountId: any) {
        return http.doGet('/admin/stats/' + accountId + '/online');
    }
};
